import { NgModule } from "@angular/core";
import { BrokerResolverService } from "src/app/sse/broker-resolver.service";
import { BrokerService } from "src/app/sse/broker.service";

@NgModule({
  imports: [],
  declarations: [],
  providers: [BrokerService, BrokerResolverService]
})
export class BrokerModule {}
